import React from "react";
import ServiceDetail from "./ServiceDetail";
import SocialMediaBanner from "../../Components/Assets/Social-Media-Banner.jpeg";

function SocialMedia() {
  return (
    <ServiceDetail
      eyebrow="Social Media"
      title="Social Media Design & Management Packages"
      description="Professional social media content and strategy designed to grow your audience, increase engagement, and build a strong online presence."
      ctaText="Boost My Social Media"

      heroImage={SocialMediaBanner}

      packages={[
        {
          name: "Starter Social",
          subtitle: "Best for getting started",
          price: 250,
          features: [
            "8 custom posts per month",
            "Basic content design",
            "1 platform (Instagram or Facebook)",
            "Caption writing",
            "Basic hashtag strategy",
          ],
        },
        {
          name: "Growth Social",
          subtitle: "Best for consistent growth",
          price: 600,
          featured: true,
          features: [
            "12–16 custom posts per month",
            "Branded content design",
            "2 platforms (Instagram + Facebook)",
            "Caption writing + engagement prompts",
            "Hashtag strategy + optimization",
            "Content calendar",
          ],
        },
        {
          name: "Premium Social",
          subtitle: "Full social media presence",
          price: 1200,
          features: [
            "20+ custom posts per month",
            "Advanced branded content",
            "Up to 3 platforms",
            "Content strategy + planning",
            "Audience growth strategy",
            "Monthly performance insights",
          ],
        },
      ]}
      process={[
        {
          title: "Strategy",
          text: "We define your target audience, brand voice, and content direction.",
        },
        {
          title: "Content Creation",
          text: "We design high-quality posts tailored to your brand and audience.",
        },
        {
          title: "Growth",
          text: "We optimize content and strategy to improve engagement and reach.",
        },
      ]}
    />
  );
}

export default SocialMedia;